import axios from "axios"
import bridge from "./bridge"
/**
 * el sf_fecha no sirve porque no existe en la mayoria de los casos, por ejemplo en movimientos 
 * que no son ventas y en ventas borradas, usar campo fecha
 */
class GG {
    mediosPagoGenericos = {
        1: "Efectivo",
        2: "Ticket",
        3: "Tarjeta",
        4: "Cheque",
        5: "Otros",
        6: "Cta.Cte.",
        32: "Retiro de Caja",
        31: "Ingreso a Caja"
    }
    getVenta(idVenta) {
        let sql = `SELECT idventa, v.estado as estado, fecha, sf_hora, tmesa, smesa, TIPOFACTURA, 
        NUMEROTICKET, total, v.nombres, e.numero as nromozo, e.nombres as mozo, v.horaapertura, v.horacierre, v.RECEP_NRODOC,
        v.tipo, pagoL2, pagoL2t, isModifiedByIDVenta, pagomultiple, FIS_NRODOC, FIS_NOMCLI, m.nombre as mesa
        FROM ventas v 
        left join empleados e on (v.idmozo = e.id)
        left join mesas m on (v.idmesa = m.id)
        where v.idventa = ${idVenta} `
        return bridge.post('v1/recordset',sql)        
    }
    getVentasDH(desde,hasta) {
        let sql = `SELECT idventa, v.estado as estado, fecha, sf_hora, tmesa, smesa, TIPOFACTURA, 
        NUMEROTICKET, total, v.nombres, e.numero as nromozo, e.nombres as mozo,
        tipo, pagoL2, pagoL2t, isModifiedByIDVenta, pagomultiple, FIS_NRODOC, FIS_NOMCLI 
        FROM ventas v left join empleados e on (v.idmozo = e.id) where v.fecha between '${desde.replace(/-/g,'')}' and '${hasta.replace(/-/g,'')} 23:59:59'
        and v.estado <> 1 `
        return bridge.post('v1/recordset',sql)
    }
    getDescuentos(desde,hasta) {
        let sql = `
        SELECT
           empleados.numero,
           v.idventa,
           v.fecha,
           v.SF_hora,
           v.SF_fecha,
           v.horaapertura,
           v.horacierre,
           v.FIS_NRODOC,
           v.TicketControl,
           v.TIPOFACTURA,
           v.NUMEROSUC,
           v.NUMEROTICKET,
           concat(v.apellidos, ' ', v.nombres) AS CLIENTE,
           concat(EMPLEADOS.APELLIDOS, ' ', EMPLEADOS.NOMBRES) AS MOZO_REP,
           v.total,
           v.concepto,
           usuarios.apodo,
           v.subtotal,
           v.descuento,
           v.montopagado,
           v.tipo,
           v.estado,
           v.dinerodevuelto,
           v.moto,
           v.interno,
           v.diraltura,
           v.dirpiso,
           v.direntrea,
           v.direntreb,
           v.direccion,
           v.localidad,
           v.codigopostal,
           v.notacliente,
           v.notarepartidor,
           v.teluno,
           v.provincia,
           v.mediopago,
           v.demoratotal,
           v.PagoL2,
           v.PagoL2T,
           v.HoraRecibido,
           v.HoraPedido,
           v.smesa AS MESA,
           v.tmesa AS TIPOMESA,
           v.tipo,
           (select sum(monto) from ventasDetail vd where vd.idventa = v.Idventa and vd.idproducto in (-6,-7)) as vddescuento,
           (select top 1 usuario from Auditoria a where codigo = 22 and idVenta  = v.Idventa) as usuario           
       FROM
           ventas v
       LEFT JOIN clientes ON
           v.idcliente = clientes.Id
       LEFT JOIN empleados ON
           v.idmozo = empleados.Id
       LEFT JOIN usuarios ON
           v.idusuario = usuarios.Id
       LEFT JOIN (
           SELECT idventa
           FROM ventasDetail
           WHERE idproducto IN (-6, -7)
           GROUP BY idventa
           HAVING SUM(monto) <> 0
       ) AS descuento_detail ON v.Idventa = descuento_detail.idventa	
       Where
           COALESCE (v.NUMEROTICKET,0)>= 0
           and v.sf_fecha between '${desde.replace(/-/g,'')}' and '${hasta.replace(/-/g,'')}'
           and v.TIPOFACTURA in ('A','B','X')
           and (select sum(monto) from ventasDetail vd where vd.idventa = v.Idventa and vd.idproducto in (-6,-7)) <> 0 
       `
        return bridge.post('v1/recordset',sql)
    }    
    getVentaMedioDePago(desde,hasta) {
        let sql = `
        SELECT
        empleados.numero,
        vd.idventadetail,
        v.idventa,
        v.fecha,
        v.SF_hora,
        v.SF_fecha,
        v.horaapertura,
        v.horacierre,
        v.FIS_NRODOC,
        v.TicketControl,
        v.TIPOFACTURA,
        v.NUMEROSUC,
        v.NUMEROTICKET,
        concat(v.apellidos, ' ', v.nombres) AS CLIENTE,
        concat(EMPLEADOS.APELLIDOS, ' ', EMPLEADOS.NOMBRES) AS MOZO_REP,
        v.total,
        v.concepto,
        usuarios.apodo,
        v.subtotal,
        v.descuento,
        v.montopagado,
        v.tipo,
        v.estado,
        v.dinerodevuelto,
        v.moto,
        v.interno,
        v.diraltura,
        v.dirpiso,
        v.direntrea,
        v.direntreb,
        v.direccion,
        v.localidad,
        v.codigopostal,
        v.notacliente,
        v.notarepartidor,
        v.teluno,
        v.provincia,
        v.mediopago,
        v.demoratotal,
        v.PagoL2,
        v.PagoL2T,
        v.HoraRecibido,
        v.HoraPedido,
        v.smesa AS MESA,
        v.tmesa AS TIPOMESA,
        v.tipo,       
        vd.NombreArticulo as mediodepago,
        vd.monto as importePago,
        s.idpuesto
    FROM
        ventas v
    inner join ventasDetail vd on
         vd.idventa = v.Idventa
      inner join sesion s on v.idsesion = s.Idsesion
  LEFT JOIN clientes ON
        v.idcliente = clientes.Id
    LEFT JOIN empleados ON
        v.idmozo = empleados.Id
    LEFT JOIN usuarios ON
        v.idusuario = usuarios.Id	
    Where
        COALESCE (v.NUMEROTICKET,0)>= 0
        and v.sf_fecha between '${desde.replace(/-/g,'')}' and '${hasta.replace(/-/g,'')}'
        and v.TIPOFACTURA in ('A','B','X')
        and vd.idproducto = -8 `
        return bridge.post('v1/recordset',sql)
    }        
    getVentasHora(desde,hasta) {
        let sdesde = desde.replace(/-/g,'')
        let shasta = hasta.replace(/-/g,'')
        let sql = `SELECT CONVERT(date, ventasdetail.fecha) as x_fecha, DATEPART(hour,ventasdetail.hora) AS x_hora, ventasDetail.NombreArticulo, Sum(CASE WHEN CHARINDEX('N',tipofactura)>0 THEN -VENTASDETAIL.CANTIDAD ELSE VENTASDETAIL.CANTIDAD END) AS SumOfcantidad, ventasDetail.monto, [monto]*Sum(CASE WHEN CHARINDEX('N',tipofactura)>0 THEN -VENTASDETAIL.CANTIDAD ELSE VENTASDETAIL.CANTIDAD END) AS imp  FROM ((ventas INNER JOIN ventasDetail ON ventas.Idventa = ventasDetail.idventa) left JOIN productos ON ventasDetail.idproducto = productos.Id) left JOIN rubros ON productos.idrubro = rubros.IdR  Where ventas.estado <> 3  and (ventasdetail.idproducto > 0 or ventasdetail.idproducto in (-5,-36,-35,-7,-6))  and ventas.fecha between '${sdesde}' and '${shasta}' and (ventasdetail.noimprimir is null or (ventasdetail.monto<>0 and ventasdetail.noimprimir<>1))  and ventasdetail.idproducto<>-7  
        GROUP BY CONVERT(date, ventasdetail.fecha), DATEPART(hour,ventasdetail.hora), ventasDetail.NombreArticulo, ventasDetail.monto  
        ORDER BY CONVERT(date, ventasdetail.fecha), DATEPART(hour,ventasdetail.hora), NombreArticulo `
        return bridge.post('v1/recordset',sql)         
    }
    getDctos(desde,hasta) {
        let sdesde = desde.replace(/-/g,'')
        let shasta = hasta.replace(/-/g,'')
        let sql = ` SELECT ventas.fecha, Sum(CASE WHEN CHARINDEX('N',tipofactura)>0 THEN -VENTASDETAIL.CANTIDAD ELSE VENTASDETAIL.CANTIDAD END) AS SumaDecantidad, Sum(ventasDetail.monto) as Monto FROM ((ventasDetail LEFT JOIN ventas ON ventasDetail.idventa = ventas.Idventa) left JOIN productos ON ventasDetail.idproducto = productos.Id) left JOIN rubros ON productos.idrubro = rubros.IdR  WHERE (((ventas.fecha) Between '${sdesde}' And '${shasta}'))  and ventasdetail.idproducto =-7  AND ventas.estado <> 3 group by ventas.fecha`
        return bridge.post('v1/recordset',sql)         
    }
    getObs(desde,hasta) {
        let sdesde = desde.replace(/-/g,'')
        let shasta = hasta.replace(/-/g,'')
        let sql = `SELECT SUM(VentasDetail.CANTIDAD * VentasDetailObservaciones.CANTIDAD) AS qty, VentasDetailObservaciones.PRECIO, VentasDetailObservaciones.concepto FROM ( VentasDetailObservaciones INNER JOIN VENTASDETAIL ON (VENTASDETAIL.IDVENTADETAIL = VentasDetailObservaciones.IDVENTADETAIL) )INNER JOIN VENTAS ON VENTASDETAIL.IDVENTA = VENTAS.IDVENTA WHERE  ventas.fecha between '${sdesde}' and '${shasta}' GROUP BY VentasDetailObservaciones.idobservacion, VentasDetailObservaciones.PRECIO, VentasDetailObservaciones.concepto`
        return bridge.post('v1/recordset',sql)         
    }
    getVentas(idcaja) {
        let sql = `SELECT idventa, v.estado as estado, fecha, sf_hora, tmesa, smesa, TIPOFACTURA, 
        NUMEROTICKET, total, v.nombres, e.numero as nromozo, e.nombres as mozo,
        tipo, pagoL2, pagoL2t, isModifiedByIDVenta, pagomultiple, FIS_NRODOC, FIS_NOMCLI 
        FROM ventas v left join empleados e on (v.idmozo = e.id) where idsesion = ${idcaja} 
        and v.estado <> 1 `
        return bridge.post('v1/recordset',sql)
    }
    getDetalleCajaVentas(idcaja) {
        let sql = `SELECT sum(monto * cantidad) as importe, NombreArticulo 
        FROM ventasDetail vd inner join ventas v on (v.idventa = vd.idventa) where v.idsesion = ${idcaja} 
        and v.estado = 2 and vd.idproducto = -8
        group by nombreArticulo`
        return bridge.post('v1/recordset',sql)
    }    
    loadDetails(idventa) {
        let sql = `SELECT idventadetail, hora, monto, vd.estado as estado, NombreArticulo, Cantidad, Comentario, 
        e.numero as nromozo, e.nombres as mozo
        FROM ventasDetail vd left join empleados e on (vd.idmozo = e.id) where idventa = ${idventa} `
        return bridge.post('v1/recordset',sql)
    }
    getProductosBorrados(idventa) {
        let sql = 
        `SELECT idventa, idventadetail, hora, importe as monto, 3 as estado, idproducto, producto as NombreArticulo, Cantidad, '' as Comentario,
         '' as nromozo, '' as mozo, preparacion, demora, tipo, motivo, usuario
         FROM PRODUCTOS_ELIMINADOS WHERE  IDVENTA =  ${idventa}  and cantidad > 0`
        return bridge.post('v1/recordset',sql)
    }
    loadDetailsMulti(idventa) {
        let sql = `SELECT idventa, idventadetail, hora, monto, vd.estado as estado, NombreArticulo, Cantidad, Comentario, 
        e.numero as nromozo, e.nombres as mozo
        FROM ventasDetail vd left join empleados e on (vd.idmozo = e.id) where idventa in (${idventa}) `
        return bridge.post('v1/recordset',sql)
    }
    getProductosBorradosMulti(idventa) {
        let sql = 
        `SELECT idventa, idventadetail, hora, importe as monto, 3 as estado, idproducto, producto as NombreArticulo, Cantidad, '' as Comentario,
         '' as nromozo, '' as mozo, preparacion, demora, tipo, motivo, usuario
         FROM PRODUCTOS_ELIMINADOS WHERE  IDVENTA in (${idventa})  and cantidad > 0 and tipo <> 'ITEMPORVENTA'`
        return bridge.post('v1/recordset',sql)
    }    
    loadComandas(idventa) {
        let sql = `SELECT *
        FROM comandas where idventa = ${idventa} `
        return bridge.post('v1/recordset',sql)
    }
    getAuditoria(desde,hasta) {
        let sql = `SELECT *
        FROM auditoria where fecha between '${desde.replace(/-/g,'')}' and '${hasta.replace(/-/g,'')} 23:59:59' `
        return bridge.post('v1/recordset',sql)
    }    
    VentasConBorrados(desde,hasta) {
        let sql = `SELECT v.idventa, v.estado as estado, fecha, sf_hora, tmesa, smesa, TIPOFACTURA, horaapertura, horacierre,
        NUMEROTICKET, total, v.nombres, e.numero as nromozo, e.nombres as mozo,
        v.tipo, pagoL2, pagoL2t, isModifiedByIDVenta, pagomultiple, FIS_NRODOC, FIS_NOMCLI, m.nombre as mesanombre,
        (select sum(pe.importe * pe.cantidad) from productos_eliminados pe where pe.idventa = v.idventa and pe.tipo <> 'ITEMPORVENTA') as importe_eliminado 
        FROM ventas v left join empleados e on (v.idmozo = e.id) left join mesas m on(v.idmesa=m.id) where v.fecha between '${desde.replace(/-/g,'')}' and '${hasta.replace(/-/g,'')} 23:59:59'
        and (v.estado = 3 or (select count(*) as c from productos_eliminados pe where pe.idventa = v.idventa) > 0 ) 
        order by v.idventa`
        return bridge.post('v1/recordset',sql)
    }
    VentasDetallado(desde,hasta) {
        let sql = `SELECT v.idventa, v.estado as estado, fecha, sf_hora, tmesa, smesa, TIPOFACTURA, v.horaapertura, v.horacierre,
        NUMEROTICKET, v.total, v.nombres, e.numero as nromozo, e.nombres as mozo,
        v.tipo, pagoL2, pagoL2t, isModifiedByIDVenta, pagomultiple, FIS_NRODOC, FIS_NOMCLI, m.nombre as mesanombre,
        (select sum(pe.importe * pe.cantidad) from productos_eliminados pe where pe.idventa = v.idventa and pe.tipo <> 'ITEMPORVENTA') as importe_eliminado, s.idpuesto
        FROM ventas v left join empleados e on (v.idmozo = e.id) left join mesas m on(v.idmesa=m.id) left join sesion s on (s.idsesion=v.idsesion) where v.fecha between '${desde.replace(/-/g,'')}' and '${hasta.replace(/-/g,'')} 23:59:59' 
        order by v.idventa`
        return bridge.post('v1/recordset',sql)
    }    
}
class MI {
    mediosPagoGenericos = {
        1: "Efectivo",
        2: "Ticket",
        3: "Tarjeta",
        4: "Cheque",
        5: "Otros",
        6: "Cta.Cte.",
        32: "Retiro de Caja",
        31: "Ingreso a Caja"
    }    
    getVentas(idcaja) {
        let sql = `SELECT idventa, v.estado as estado, fecha, sf_hora, tmesa, smesa, TIPOFACTURA, 
        NUMEROTICKET, total, v.nombres, e.numero as nromozo, e.nombres as mozo,
        tipo, pagoL2, pagoL2t, isModifiedByIDVenta, pagomultiple, FIS_NRODOC, FIS_NOMCLI 
        FROM _gg_ventas v left join _gg_empleados e on (v.idmozo = e.id and v.licence_id = e.licence_id) where v.licence_id = ${window.licenceid} and  idsesion = ${idcaja} 
        and v.estado <> 1 `
        return axios.post(process.env.VUE_APP_baseURL+'recordset/',{query:sql},{headers:{Authorization:process.env.VUE_APP_AUTH_TOKEN}})
    }
    loadDetails(idventa) {
        let sql = `SELECT idventadetail, hora, monto, vd.estado as estado, NombreArticulo, Cantidad, Comentario, 
        e.numero as nromozo, e.nombres as mozo
        FROM _gg_ventasDetail vd left join _gg_empleados e on (vd.idmozo = e.id and vd.licence_id = e.licence_id) where vd.licence_id = ${window.licenceid} and idventa = ${idventa} `
        return axios.post(process.env.VUE_APP_baseURL+'recordset/',{query:sql},{headers:{Authorization:process.env.VUE_APP_AUTH_TOKEN}})
    }
    loadComandas(idventa) {
        let sql = `SELECT *
        FROM _gg_Comandas where licence_id = ${window.licenceid} AND idventa = ${idventa} `
        return axios.post(process.env.VUE_APP_baseURL+'recordset/',{query:sql},{headers:{Authorization:process.env.VUE_APP_AUTH_TOKEN}})
    }
    getAuditoria(desde,hasta) {
        let sql = `SELECT *
        FROM _gg_Auditoria where licence_id = ${window.licenceid} AND fecha between '${desde}' and '${hasta} 23:59:59' `
        return axios.post(process.env.VUE_APP_baseURL+'recordset/',{query:sql},{headers:{Authorization:process.env.VUE_APP_AUTH_TOKEN}})
    }       
    getVentaMedioDePago(desde,hasta) {
        let sql = `
        SELECT
        _gg_empleados.numero,
        vd.idventadetail,
        v.idventa,
        v.fecha,
        v.SF_hora,
        v.SF_fecha,
        v.horaapertura,
        v.horacierre,
        v.FIS_NRODOC,
        v.TicketControl,
        v.TIPOFACTURA,
        v.NUMEROSUC,
        v.NUMEROTICKET,
        concat(v.apellidos, ' ', v.nombres) AS CLIENTE,
        concat(_gg_empleados.apellidos, ' ', _gg_empleados.nombres) AS MOZO_REP,
        v.total,
        v.concepto,
        _gg_usuarios.apodo,
        v.subtotal,
        v.descuento,
        v.montopagado,
        v.tipo,
        v.estado,
        v.dinerodevuelto,
        v.moto,
        v.interno,
        v.diraltura,
        v.dirpiso,
        v.direntrea,
        v.direntreb,
        v.direccion,
        v.localidad,
        v.codigopostal,
        v.notacliente,
        v.notarepartidor,
        v.teluno,
        v.provincia,
        v.mediopago,
        v.demoratotal,
        v.PagoL2,
        v.PagoL2T,
        v.HoraRecibido,
        v.HoraPedido,
        v.smesa AS MESA,
        v.tmesa AS TIPOMESA,
        v.tipo,       
        vd.NombreArticulo as mediodepago,
        vd.monto as importePago,
        s.idpuesto
    FROM
        _gg_ventas v
    inner join _gg_ventasDetail vd on
         (vd.idventa = v.Idventa and vd.licence_id = v.licence_id)
      inner join _gg_sesion s on (v.idsesion = s.Idsesion and v.licence_id = s.licence_id)
    LEFT JOIN _gg_empleados ON
        (v.idmozo = _gg_empleados.Id and v.licence_id = _gg_empleados.licence_id)
    LEFT JOIN _gg_usuarios ON
        (v.idusuario = _gg_usuarios.Id and v.licence_id = _gg_usuarios.licence_id)
    Where
        COALESCE (v.NUMEROTICKET,0)>= 0
        and v.sf_fecha between '${desde}' and '${hasta} 23:59:59'
        and v.TIPOFACTURA in ('A','B','X')
        and vd.idproducto = -8 
        and v.licence_id = ${window.licenceid}; `
        return axios.post(process.env.VUE_APP_baseURL+'recordset/',{query:sql},{headers:{Authorization:process.env.VUE_APP_AUTH_TOKEN}})
    }            
}
export function Ventas() {
    if (window.datasource=="MI") {
        return new MI
    } else {
        return new GG
    }
}
